/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { VicnamesRadiusDto } from '../../models/vicnames-radius-dto';

export interface GetVicnamesRadiusFromCoordinates$Params {
  latitude: string;
  longitude: string;
}

export function getVicnamesRadiusFromCoordinates(
  http: HttpClient,
  rootUrl: string,
  params: GetVicnamesRadiusFromCoordinates$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<VicnamesRadiusDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    getVicnamesRadiusFromCoordinates.PATH,
    'get',
  );
  if (params) {
    rb.query('latitude', params.latitude, {});
    rb.query('longitude', params.longitude, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VicnamesRadiusDto>;
      }),
    );
}

getVicnamesRadiusFromCoordinates.PATH = '/vicnames/search/radius';
